import React from "react";
import { IndexRouteObject, NonIndexRouteObject } from "react-router-dom"
import { BreadcrumbComponentProps } from "use-react-router-breadcrumbs"

type NavRouteIndex = IndexRouteObject & { 
    breadcrumb?: string | (({}:BreadcrumbComponentProps) => React.ReactElement);
    children?: undefined;
}

type NavRouteNonIndex = NonIndexRouteObject & {
    breadcrumb?: string | (({}:BreadcrumbComponentProps) => React.ReactElement);
    children?: NavRoute[];
}

type NavRoute = NavRouteIndex | NavRouteNonIndex

type RouteMenuItem = {
    to: string;
    label: string;
    icon: string;
}

export type NavContextType = {
    routes: NavRoute[];
    overlays?: NavRoute[];
    menu: RouteMenuItem[];
    mobile: RouteMenuItem[];
}

export const NavContext = React.createContext<NavContextType>({routes:[],overlays:[],menu:[],mobile:[]});